export default {
  fontSizes: {
    tiny: '10px',
    small: '12px',
    smallish: '14px',
    medium: '16px',
    largish: '20px',
    large: '24px',
    xlarge: '32px',
    xxlarge: '40px',
  },
  fontWeights: {
    tiny: 100,
    small: 200,
    smallish: 300,
    medium: 400,
    largish: 500,
    large: 600,
    xlarge: 700,
    xxlarge: 800,
  },
  shadows: {
    cardHover: 'rgb(211, 212, 214) 0px 20px 10px -12px',
  },
  sizes: {
    'container-max-width': '1172px',
    'container-side-padding': '15px',
  },
  breakPoints: {
    mobileNav: '1050px',
    xsmall: '480px',
    small: '768px',
    medium: '1024px',
    large: '1280px',
  },
  colors: {
    alterTableRowBackground: '#F4F7F7',
    borderGray: '#DDDDDD',
    brightBlue: '#0c5fe0',
    darkGray: '#77777c',
    dashboardGray: '#F4F7F8',
    expressiveNegativeBase: '#d51c26', // alchemy expressiveNegative.base
    expressivePositiveBase: '#19b135', // alchemy expressivePositive.base
    gold: '#F0B80F',
    gray: '#8B8B8B',
    highlightBlue: '#ebf2fd',
    highlightGreen: '#bcf7dd',
    inputBackground: '#f5f8f8',
    inputColor: 'rgba(0, 0, 0, 0.87)',
    inputErrorBackground: '#fff6f6',
    lightBlue: '#ebf2fd',
    lightestGreen: '#f0fbf6',
    lightYellow: '#fef6d7',
    stellaBlack: '#333333',
    stellaBlue: '#335168',
    stellaGold: '#d6b73d',
    stellaGray: '#afa8aa',
    stellaGreen: '#01c783',
    stellaLightGraySmoke: '#f1f1f1',
    stellaLightShadeGreen: '#88bb88',
    stellaLightWhiteSmoke: '#f5f8f8',
    stellaNavy: '#325168',
    stellaOrange: '#f39316',
    stellaPlaceholder: '#8B8B8B',
    stellaRed: '#ff5e51',
    structuralConstructiveBase: '#2e77d0',
    structuralConstructiveContrast: '#1147b3',
    structuralConstructiveHighlight: '#b9dfff',
    structuralConstructiveHint: 'eaf3ff',
    styleGuideBrightBlue: '#06a9e2',
    styleGuideRed: '#c24b31',
    styleGuideYellow: '#fde64a',
    transparentGray: 'rgba(0, 0, 0, 0.09)',
    typeBody: '#1b2437',
    veryLightGray: '#fafafa',
    white: '#ffffff',
    yellow: '#F2C94C',
  },
};
